var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.menuList.length !== 0
        ? _c("draggerBox", {
            attrs: {
              menuList: _vm.menuList,
              loading: _vm.saveLoading,
              type: 5,
              buttonName: _vm.btnName,
              auth: _vm.auth,
            },
            on: { save: _vm.onSave, initSuccess: _vm.getListData },
          })
        : _c("ZDefaultData", {
            attrs: {
              custom: {
                desc: _vm.$t("system::common::tips::quick_setting"),
                img: require("@/assets/images/emptyDefault/emptyCard1.png"),
                buttons: [
                  {
                    btnClick: _vm.initData,
                    text: _vm.$t("after-sales::email-setting::email_sort_init"),
                    type: "text",
                    auth: "after-sales::email-setting::replied",
                  },
                ],
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }